import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ForgotPassState } from './redux';

export const forgotPassSelector = (state: RootState) => state.forgotPass;
export const forgotPassSelect = createSelector(forgotPassSelector, (state: ForgotPassState) => state);
export const showModalInputEmailSelector = createSelector(forgotPassSelector, (state: ForgotPassState) => state.showModalInputEmail);
export const showModalResetPassSelector = createSelector(forgotPassSelector, (state: ForgotPassState) => state.showModalResetPass);
export const fieldErrorsSelector = createSelector(forgotPassSelector, (state: ForgotPassState) => state.fieldErrors);
